module.exports = __webpack_public_path__ + "static/media/corrugated-face.5926372d.jpg";